import { getCmsDestinationBySlug } from "../../../app/api/getCmsDestinationBySlug";
import { getCmsNetworkMapStationsBySlug } from "../../../app/api/getCmsNetworkMapStationsBySlug";
import { BaseAction } from "../../../core/actions/BaseAction";
import { _eventBus } from "../../../core/events/EventBus";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse, ICmsNetworkDetail, ICmsNetworkDetailResponse, IGetBookingCodesActionParams, IGetNetworkDetailActionParams } from "../../../Orchestrator/Types/Index";

class TripBookClickAction extends BaseAction<void, IGetBookingCodesActionParams> {
  override async run(): Promise<void> {
    try {
      const { searchData, isAuthenticated } = this.params!;
      updateRecoilState("searchStateAtom", searchData);
      if (isAuthenticated) {
        _eventBus.emit({
          eventName: "ROUTE_CHANGE",
          data: "/search",
        })
      } else {
        _eventBus.emit({
          eventName: "ROUTE_CHANGE",
          data: "/",
        })
      }
    } catch (error: any) {
      console.error("Error fetching stationData:", error);
    } finally {

    }
  }
}

export const tripBookClickAction = new TripBookClickAction();
